import * as React from 'react'
import { useParams } from 'react-router-dom'

import {
  UniversalImporterFixProcessPageDocument,
  UniversalImporterFixProcessPageQuery,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { ImportProcessDataCollection } from 'modules/universal_importer/components/ImportProcessDataCollection'
import { ImportProcessErrorModal } from 'modules/universal_importer/components/ImportProcessErrorModal'
import { ImportProcessInfoBanner } from 'modules/universal_importer/components/ImportProcessInfoBanner'
import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'
import { Metadata } from 'modules/universal_importer/components/NuvoImporter/types'
import { metadataInputToMetadata } from 'modules/universal_importer/components/NuvoImporter/useGetMetadata'

const UniversalImporterProcessPage = () => {
  const { importProcessId } = useParams()
  const { navigation } = useNavigation()
  const [isFixModalOpen, setIsFixModalOpen] = React.useState(false)
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [selectedRowErrors, setSelectedRowErrors] = React.useState<string>('')
  const [selectedRowColumns, setSelectedRowColumns] = React.useState<Record<string, string>>({})

  const {
    company,
    access: { locale },
  } = useCurrentSession()

  const { data, loading } = useQuery(UniversalImporterFixProcessPageDocument, {
    variables: { importProcessId: String(importProcessId) },
  })

  type UniversalImporterImportProcessMetadata = NonNullable<
    NonNullable<
      NonNullable<UniversalImporterFixProcessPageQuery['universalImporter']>['importProcess']
    >['metadata']
  >[number]

  const importProcess = data?.universalImporter.importProcess
  const metadata_import_process: UniversalImporterImportProcessMetadata[] | undefined =
    importProcess?.metadata || undefined

  const metadataFromProcess: Metadata = metadata_import_process
    ? metadataInputToMetadata(
        metadata_import_process.map((item) => ({
          key: item.key,
          values: item.values,
          type: item.type,
        }))
      )
    : {}

  const metadata: Metadata = {
    ...metadataFromProcess,
    import_process_ids: importProcessId ? [BigInt(importProcessId)] : [],
  }
  const parentProcessId = importProcess?.id
  const rootProcessId = importProcess?.rootProcessId ?? parentProcessId

  return (
    <ResponsivePage.Body
      variant="full"
      loading={loading}
      error={!importProcess}
      onActionClick={(key) => {
        if (key === 'fix-import-process') {
          setIsFixModalOpen(true)
        }
      }}
    >
      <ImportProcessInfoBanner />
      <ImportProcessDataCollection
        setSelectedRowColumns={setSelectedRowColumns}
        setSelectedRowErrors={setSelectedRowErrors}
        setIsModalOpen={setIsModalOpen}
        setIsFixModalOpen={setIsFixModalOpen}
        importProcessId={String(importProcessId)}
      />
      <ImportProcessErrorModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedRowErrors={selectedRowErrors}
        selectedRowColumns={selectedRowColumns}
      />
      {isFixModalOpen && importProcess && (
        <NuvoImporter
          importType={importProcess.importType}
          companyId={company.id}
          locale={locale}
          metadata={metadata}
          isEdition={importProcess?.action === 'edit' || false}
          customBackNavigation={navigation.settings.universalImporter.universalImporterProcess
            .fullPath({
              importProcessId: String(importProcessId),
            })
            .replace(/\*+$/, '')}
          parentProcessId={parentProcessId}
          rootProcessId={rootProcessId}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default UniversalImporterProcessPage
